var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCerteidas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    y: "0px",
    x: "0px",
    width: "300px",
    height: "300px",
    viewBox: "0 0 79.375 79.375",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.8587 0 0 1.8587 -7.8266 -3.9533)",
    strokeWidth: 0.538
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m98.365 29.195c-0.77328 0.02711-1.5583 0.37677-2.3066 1.1875-9.4802 12.923-17.795 26.217-23.379 40.387-3.0197 5.9255-3.8897 12.944-1.9531 19.762 3.86 13.588 17.625 21.999 31.477 19.23 13.852-2.7688 23.332-15.831 21.672-29.859-0.6876-1.9052-5.0913 0.17007-6.1777 0.64062-1.0865 0.47056-2.3347 1.4056-3.3906 2.3027-0.38185 0.38185-1.5602 1.6057-1.8359 3.1309-1.1283 6.2419-5.9361 11.35-12.49 12.66-8.1556 1.6302-16.079-3.2047-18.352-11.205-2.2727-8.0004 1.928-16.285 9.7227-19.186 6.4397-2.3966 13.42-0.40655 17.633 4.6094 0.88627 1.0553 1.9846 1.36 2.8789 1.6289 1.2239 0.32795 3.7772 0.1462 4.7344 0.01758 0.95715-0.12862 5.991-1.0266 4.9238-2.875-4.4719-9.6043-13.988-15.457-24.051-15.701-1.6247-0.03947-3.2628 0.07007-4.8965 0.33203 2.4626-5.3421 6.8714-9.7471 10.209-14.668 1.4934-2.1676 1.9813-5.2354 0.91602-7.7656-0.79894-1.8977-3.0142-4.7102-5.334-4.6289z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    fill: "#1a3f8f",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "markers fill stroke",
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0d9bd9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.09,
    cy: 21.898,
    r: 0.49019,
    style: {
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.713,
    cy: 21.898,
    r: 0.49019,
    style: {
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.249,
    cy: 21.898,
    r: 0.49019,
    style: {
      paintOrder: "markers fill stroke"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.208 10.123c-0.76705 4.3036-0.94545 6.6864-0.89456 9.3998l0.64663-1.5163c0.6963-1.7616 2.191-4.5313 3.1519-6.0064 0.10181-0.68896-0.14025-1.4743-0.68838-1.951-0.54811-0.47663-1.8829-1.0454-2.2156 0.07392z",
    fill: "#009ee0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.761 21.682-0.09154-2.0241c0.04792-1.8936 0.11098-3.5997 0.36206-5.3067 0.16236-1.2963 0.21041-1.1543-0.11264-1.2408-0.32305-0.08656-2.1175-0.50482-1.971 0.8623 0.30744 2.8697 0.92299 5.1426 1.8131 7.7093z",
    fill: "#7ccef6"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#174090"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.503 37.167c-0.04734 0.53018-0.34083 0.88048-0.7574 0.88048-0.54911 0-0.63468-0.52071-0.63468-1.5527 0-1.013 0.11397-1.5432 0.70095-1.5432 0.38817 0 0.59645 0.24615 0.70059 0.8142h1.0982c-0.04734-0.50178-0.11361-0.74793-0.27456-1.0414-0.31243-0.56805-0.88994-0.88994-1.5716-0.88994-1.2308 0-1.9952 1.013-1.9952 2.7172 0 1.6568 0.71709 2.5846 1.9384 2.5846 1.0698 0 1.7325-0.69113 1.8935-1.9692z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.646 37.553c-0.10414 0.35976-0.97309 0.6276-1.44 0.4428-0.40722-0.16116-0.58518-0.29836-0.65145-1.141h2.7127v-0.23669c0-1.7894-0.70059-2.7834-1.9598-2.7834-1.2213 0-2.0188 0.98461-2.0188 2.632 0 1.7041 0.78805 2.6226 2.0756 2.6226 0.46391 0 1.0174-0.0262 1.3299-0.3008 0.3503-0.29349 0.33575-0.28949 0.52576-0.4795zm-2.0631-1.5692c0.09468-0.72899 0.23218-1.0604 0.71502-1.0604 0.49231 0 0.61097 0.35029 0.68671 1.0604z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.051 39.004h1.2967v-2.6225c0-0.8142 0.0086-1.2024 0.86168-1.2024 0.12512 0 0.23887 9e-3 0.32986 0.0189v-1.3444c-0.14787-0.0189-0.20474-0.0189-0.26162-0.0189-0.63698 0-0.74224 0.22546-0.97543 0.61434v-0.4818h-1.2512z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.933 32.604h-1.2192v1.3633h-0.63099v0.94675h0.63099v3.058c0 0.79526 0.34223 1.1347 1.2406 1.1347h0.16042c0.13903 0 0.38827-0.0292 0.58821-0.0648v-1.0954c-0.13903 0.0189-0.1925 0.0189-0.26737 0.0189-0.42779 0-0.50265-0.0568-0.50265-0.40711v-2.6442h0.77002v-0.94675h-0.77002z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.072 33.92v5.0839h1.3155v-5.0839z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.259 31.793h-1.3037v2.5844c-0.23687-0.43343-0.67219-0.60159-0.97794-0.60159-1.2777 0-1.7325 1.091-1.7325 2.6531 0 1.6473 0.45724 2.7077 1.742 2.7077 0.55858 0 0.94675-0.45643 1.0465-0.67715v0.5446h1.2257zm-1.9503 3.1969c0.57752 0 0.64902 0.56805 0.64902 1.5527 0 0.95621-0.08097 1.5053-0.68689 1.5053-0.55858 0-0.68445-0.59645-0.68445-1.5432 0-0.95621 0.12587-1.5148 0.72232-1.5148z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.476 35.454c0.05446-0.48763 0.11388-0.55886 0.57779-0.55886 0.44497 0 0.43309 0.18935 0.43309 0.56805 0 0.23669-0.01431 0.47921-0.01431 0.47921l-1.1004 0.04624c-0.77633 0.14201-1.2828 0.79052-1.2828 1.671 0 0.90888 0.67188 1.4769 1.3586 1.4769 0.55941 0 0.68837 0.0027 1.1144-0.5369 0.0284 0.27456 0.03787 0.21667 0.10414 0.46282h1.3566v-0.132c-0.13214-0.22888-0.23669-0.59417-0.23669-1.0865v-2.5512c0-0.91835-0.61538-1.458-1.6852-1.458-0.71006 0-1.2638 0.17284-1.5573 0.60834-0.17988 0.2935-0.28871 0.45228-0.34552 1.0109zm0.99523 2.2095c0 0.24008-0.17129 0.42196-0.70147 0.42196-0.15903 0-0.35784-0.39538-0.35784-0.51099 0-0.4355 0.32014-0.73794 0.5756-0.80639 0.30687 0 0.35312-5.23e-4 0.48372 0.03447z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.316 35.434c-0.0852-0.70059-0.21052-0.95567-0.55134-1.2302-0.29349-0.23669-0.80416-0.36923-1.3154-0.36923-0.69113 0-1.2168 0.19074-1.5009 0.67358-0.16095 0.27456-0.25033 0.55998-0.25033 0.99798 0 0.63797 0.41093 1.0394 1.4856 1.492 0.54097 0.22783 0.90359 0.42295 0.90359 0.68804 0 0.32189-0.26203 0.47477-0.50544 0.47477-0.58698 0-0.71955-0.1604-0.73848-0.66218h-1.2591c0.06627 0.69113 0.19882 0.89915 0.55858 1.1926 0.34083 0.28403 0.5461 0.44498 1.4012 0.44498 1.1361 0 1.8116-0.52268 1.8116-1.583 0-0.29349-0.04124-0.49594-0.16429-0.70422-0.21775-0.3503-0.49668-0.51629-1.1002-0.79527-0.57649-0.26647-1.0987-0.40095-1.0987-0.73286 0-0.31243 0.23557-0.47337 0.45698-0.47337 0.47337 0 0.48733 0.09412 0.56307 0.58643z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.641 37.553c-0.10414 0.35976-0.97309 0.6276-1.44 0.4428-0.40722-0.16116-0.58518-0.29836-0.65145-1.141h2.7127v-0.23669c0-1.7894-0.70059-2.7834-1.9598-2.7834-1.2213 0-2.0188 0.98461-2.0188 2.632 0 1.7041 0.78805 2.6226 2.0756 2.6226 0.46391 0 1.0174-0.0262 1.3299-0.3008 0.3503-0.29349 0.33575-0.28949 0.52576-0.4795zm-2.0631-1.5692c0.09468-0.72899 0.23218-1.0604 0.71502-1.0604 0.49231 0 0.61097 0.35029 0.68671 1.0604z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.751,
    cy: 32.576,
    r: 0.72642,
    fillRule: "evenodd",
    style: {
      paintOrder: "markers fill stroke"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerteidas);
export default __webpack_public_path__ + "static/media/certeidas.e449f7aed648166872f39a5e27f423f4.svg";
export { ForwardRef as ReactComponent };